import * as React from 'react';
import { ASPECT_RATIO } from 'mm-theme-configuration/dist/consts';
import { LazyImage } from './lazyImage/LazyImage';
import { getCalculatedThumbnail } from './image.utils';
import { EagerImage } from './eagerImage/EagerImage';
import { OptionalAdditionalStyle } from '../../components.utils';
import { ImageWrapper } from './ImageWrapper';
import { Thumbnail } from './image.types';

export interface ImageDataProps {
  lazyLoad?: boolean,
  dataId?:string
  aspectRatioLarge?: ASPECT_RATIO,
  aspectRatioMedium?: ASPECT_RATIO,
  aspectRatioSmall?: ASPECT_RATIO,
}
type ImageProps = ImageDataProps & OptionalAdditionalStyle & Thumbnail;

export const Image: React.FunctionComponent<ImageProps> = props => {
  const { description, host, path, aspectRatio = { x: 16, y: 9 }, additionalStyle, lazyLoad, dataId, baseStyleConfiguration } = props;
  const { aspectRatioLarge = aspectRatio, aspectRatioSmall = aspectRatio, aspectRatioMedium = aspectRatio } = props;
  const CalculatedImage = lazyLoad ? LazyImage : EagerImage;
  return (
    <ImageWrapper aspectRatioLarge={aspectRatioLarge} aspectRatioSmall={aspectRatioSmall} aspectRatioMedium={aspectRatioMedium} additionalStyle={additionalStyle} dataId={dataId} baseStyleConfiguration={baseStyleConfiguration}>
      <CalculatedImage {...getCalculatedThumbnail({ aspectRatioLarge, aspectRatioMedium, aspectRatioSmall }, description, host, path)} />
    </ImageWrapper>
  );
};
